export default defineNuxtRouteMiddleware((to, from) => {
  /*if (to.name && to.name.includes('___en')) {
    const { name, query, hash } = to
    const nextName = name.replace('___en', '___it')
    const nextRoute = { name: nextName, query, hash }
    return navigateTo(nextRoute, { redirectCode: 302 })
  }*/
})
